import React, {useState,useEffect} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
//import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
//import TableCell from '@mui/material/TableCell';
//import TableRow from '@mui/material/TableRow';
//import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
//import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
//import VisibilityIcon from '@mui/icons-material/Visibility';
//import BookIcon from '@mui/icons-material/Book';
import EditIcon from '@mui/icons-material/Edit';
//import CheckIcon from '@mui/icons-material/Check';
//import MultiLines from './MultiLines';
import {Inc,Owner} from './Inc';
//import StoreImg from './StoreImg';
import RowTable from './RowTable';
import BottomButtons from './BottomButtons';

//import {Tools} from './Tools';
import Ajax from './Ajax';
import Loading from './Loading';
import Title from './Title';


interface Props {
	owner:Owner,
	managerId:number,
}

const BankDetail = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        bank: Inc.defaultOwnerBank(),
        isLoading:true,
    });

    useEffect( ()=>{
        //console.log("managerId:",props.managerId);
        if( props.managerId>0 ){
            Ajax.send("bank/get",{manager_id:props.managerId},(res:any)=>{
                //console.log(res);
                if( res.ok ){
                    setStates({...states,"isLoading":false,"bank":Inc.convOwnerBank(res.bank)})
                } else {
                    setStates({...states,"isLoading":false})
                }
            });
        } else {
            setStates({...states,"isLoading":false});
        }
    } ,[]);

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

	return (
		<div id="bank_detail" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="支払口座" icon="portrait"/>
                        <div style={{marginBottom:"2em"}}>
                        作品の売上は金融機関（ゆうちょ・銀行・信用金庫など）への振り込みでお支払いたします。<br/>
						{states.bank.bank_code && props.owner.switch_id===1 &&
                        <div>現在登録されている支払口座は以下の通りです。変更したい場合は 「支払口座を編集」を押して下さい。</div>
						}
						{states.bank.bank_code && props.owner.switch_id>1 &&
                        <div>現在登録されている支払口座は以下の通りです。変更したい場合はプロフィールをメインプロフィールに切り替えて下さい。</div>
						}
                        </div>

						<Hidden mdUp implementation="js">
							<BottomButtons button1='支払口座を編集' link1='/bank/input' icon1={<EditIcon/>} disabled1={props.owner.switch_id>1}/>
						</Hidden>
						{states.bank.bank_code ? (
                        <Table>
                            <TableBody>
                            {states.bank.bank_type_id===1 &&
                                <React.Fragment>
                                <RowTable name="金融機関種類" value={
                                    <React.Fragment>
                                    {states.bank.bank_type}
                                    </React.Fragment>
                                } widths={["10em",""]}/>
                                <RowTable name="口座番号" value={
                                    <React.Fragment>
                                    {states.bank.bank_code}
                                    </React.Fragment>
                                }/>
                                <RowTable name="口座名義" value={
                                    <React.Fragment>
                                    {states.bank.bank_signature}
                                    </React.Fragment>
                                }/>
                                <RowTable name="支払手数料" value={
                                    <React.Fragment>
                                    振り込み1回につき{states.bank.cost}円
                                    </React.Fragment>
                                }/>
                                </React.Fragment>
                                }


                                {states.bank.bank_type_id===2 &&
                                <React.Fragment>
                                <RowTable name="金融機関種類" value={
                                    <React.Fragment>
                                    {states.bank.bank_type}
                                    </React.Fragment>
                                } widths={["10em",""]}/>
                                <RowTable name="金融機関名" value={
                                    <React.Fragment>
                                    {states.bank.bank_name}
                                    </React.Fragment>
                                }/>
                                <RowTable name="支店名" value={
                                    <React.Fragment>
                                    {states.bank.bank_store}
                                    </React.Fragment>
                                }/>
                                <RowTable name="口座種目" value={
                                    <React.Fragment>
                                    {states.bank.bank_cat}
                                    </React.Fragment>
                                }/>
                                <RowTable name="口座番号" value={
                                    <React.Fragment>
                                    {states.bank.bank_code}
                                    </React.Fragment>
                                }/>
                                <RowTable name="口座名義" value={
                                    <React.Fragment>
                                    {states.bank.bank_signature}
                                    </React.Fragment>
                                }/>
                                <RowTable name="支払手数料" value={
                                    <React.Fragment>
                                    振り込み1回につき{states.bank.cost}円
                                    </React.Fragment>
                                }/>
                                </React.Fragment>
                                }

                            </TableBody>
                        </Table>
						):(
						<div style={{marginTop:'2em',marginBottom:'4em',padding:'2em 1em',textAlign:'center',border:'1px solid silver'}}>※支払口座はまだ登録されていません。</div>
						)}
					</Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <Title text="登録・修正" size={2}/>
						{props.owner.switch_id===1 ? (
						<Hidden mdDown implementation="js">
    					<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
							<Link to="/bank/input"><Button variant="contained" color="primary" style={{width:"100%"}}><EditIcon/>支払口座を編集</Button></Link>
						</FormControl>
						</Hidden>
						):(
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}><EditIcon/>支払口座を編集</Button>
							</FormControl>
						</Hidden>	
						)}
                        <ul style={{paddingLeft:"1.5em",paddingRight:"0.5em"}}>
                            <li style={{marginBottom:"0.5em"}}>
                                口座名義が以下のいずれかである口座をご用意ください。<br/>
                                ・本人の名前<br/>
                                ・本人が所属する法人名<br/>
                                ・本人が所属するサークル名<br/>
                                ・本人の作家名<br/>
                            </li>
                            <li>
                                本人確認ができない口座の場合は、振り込みをお断りする場合がございます。
                            </li>
                        </ul>

                    </Paper>
                </Grid>
            </Grid>
		</div>
	);
}

export default BankDetail;
